import * as React from 'react';
import { ErrorBoundary } from 'bernie-view';
import { AdBanner } from '@shared-ui/retail-sponsored-content-ad-banner';
import { classNames } from 'uitk-react-utils';
export var MesoDisplayAd = function (props) {
  var _a;
  var displayAd = React.createRef();
  var className = classNames('ad-div', 'display-ad', (_a = {}, _a[props.className === undefined ? '' : props.className] = props.className, _a));
  var adBanner = React.useMemo(function () {
    var _a;
    return React.createElement(AdBanner, {
      uci: (_a = props.uci) !== null && _a !== void 0 ? _a : '',
      displayAdRef: displayAd,
      className: className
    });
  }, []);
  return React.createElement(ErrorBoundary, {
    label: "meso.display.ad"
  }, adBanner);
};
MesoDisplayAd.displayName = 'MesoDisplayAd';